
import React from 'react';

const TopContactBar = () => {
  return (
    <div className="top-contact-bar">
      <div className="container top-bar-content">
        <div className="contact-info">
          <a href="tel:+255778900681" className="contact-item">
            <i className="fas fa-phone-alt"></i>
            <span>0778 900 681</span>
          </a>
          <a href="mailto:makahmedics@gmail.com" className="contact-item">
            <i className="fas fa-envelope"></i>
            <span>makahmedics@gmail.com</span>
          </a>
          <div className="contact-item desktop-only">
            <i className="fas fa-clock"></i>
            <span>Mon - Fri: 8:00 AM - 5:00 PM</span>
          </div>
        </div>
        <div className="social-links">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="https://wa.me/255769880769" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopContactBar;